export const getQueryObjectFromSearchParams = (searchParams: URLSearchParams) =>
	Object.fromEntries(searchParams.entries() ?? []);
